import { useState, useEffect } from 'react';
import {
  createUser,
  getUser,
  getAllUsers,
  updateUser,
  deleteUser,
  getUserByUsername,
  saveChatSession,
  getChatSession,
  getUserChatSessions,
  getAllChatSessions,
  updateChatSession,
  deleteChatSession,
  saveGlobalConfig,
  getGlobalConfig,
  savePromoCodes,
  getPromoCodes,
  saveAds,
  getAds,
  saveUserPreferences,
  getUserPreferences,
  listenToUser,
  listenToUserChatSessions,
  listenToGlobalConfig,
  db,
  signOut
} from '../services/firebaseService';
import { User, ChatSession, GlobalConfig, PromoCode, AdBanner, MessageDensity } from '../types';

export const useFirebase = () => {
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    setIsInitialized(true);
  }, []);

  return {
    isInitialized,
    isConfigured: isInitialized && !!db,
    db, // Export db instance
    // Auth operations
    signOut,
    // User operations
    createUser,
    getUser,
    getAllUsers,
    updateUser,
    deleteUser,
    getUserByUsername,
    listenToUser,
    // Chat session operations
    saveChatSession,
    getChatSession,
    getUserChatSessions,
    getAllChatSessions,
    updateChatSession,
    deleteChatSession,
    listenToUserChatSessions,
    // Config operations
    saveGlobalConfig,
    getGlobalConfig,
    listenToGlobalConfig,
    // Promo codes
    savePromoCodes,
    getPromoCodes,
    // Ads
    saveAds,
    getAds,
    // User preferences
    saveUserPreferences,
    getUserPreferences
  };
};
